// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2aQ18","question":"Question_question__1OxNp","description":"Question_description__da4fa"};